import { render, staticRenderFns } from "./manage-booking-order-header.vue?vue&type=template&id=96ec8868"
import script from "./manage-booking-order-header.vue?vue&type=script&lang=ts"
export * from "./manage-booking-order-header.vue?vue&type=script&lang=ts"
import style0 from "./manage-booking-order-header.vue?vue&type=style&index=0&id=96ec8868&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports